export const isEven = (num) => num % 2 === 0;
export const delay = (ms) => new Promise((res) => setTimeout(res, ms));
